<div class="apis-container">
  <div class="header">
    <h1>API Catalog</h1>
    <p class="subtitle">Explore and view Swagger/OpenAPI specifications</p>
  </div>

  <div class="loading" *ngIf="loading">
    <div class="spinner"></div>
    <p>Loading API specifications...</p>
  </div>

  <div class="error" *ngIf="error">
    <p>{{ error }}</p>
    <button (click)="loadApiFiles()" class="retry-btn">Retry</button>
  </div>

  <div class="folders-container" *ngIf="!loading && !error && apiFolders.length > 0">
    <div class="api-folder" *ngFor="let folder of apiFolders">
      <div class="folder-header" (click)="toggleFolder(folder.folderName)" 
           [class.expanded]="isFolderExpanded(folder.folderName)"
           [class.has-files]="folder.apiFiles.length > 0">
        <div class="folder-info">
          <span class="folder-icon">
            <svg *ngIf="!isFolderExpanded(folder.folderName)" 
                 width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10 4H4C2.89543 4 2 4.89543 2 6V18C2 19.1046 2.89543 20 4 20H20C21.1046 20 22 19.1046 22 18V8C22 6.89543 21.1046 6 20 6H12L10 4Z" 
                    stroke="currentColor" 
                    stroke-width="2" 
                    stroke-linecap="round" 
                    stroke-linejoin="round" 
                    fill="currentColor" 
                    fill-opacity="0.1"/>
            </svg>
            
            <svg *ngIf="isFolderExpanded(folder.folderName)" 
                 width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <!-- Folder back part -->
              <path d="M4 4H9L11 6H20C21.1046 6 22 6.89543 22 8V9H3V6C3 4.89543 3.89543 4 5 4H4Z" 
                    stroke="currentColor" 
                    stroke-width="2" 
                    stroke-linecap="round" 
                    stroke-linejoin="round" 
                    fill="currentColor" 
                    fill-opacity="0.05"/>
              <!-- Open folder front -->
              <path d="M2 10H21C21.5523 10 22 10.4477 22 11V18C22 19.1046 21.1046 20 20 20H4C2.89543 20 2 19.1046 2 18V10Z" 
                    stroke="currentColor" 
                    stroke-width="2" 
                    stroke-linecap="round" 
                    stroke-linejoin="round" 
                    fill="currentColor" 
                    fill-opacity="0.2"/>
              <!-- Content indicator lines -->
              <path d="M6 14H18M6 16H15" 
                    stroke="currentColor" 
                    stroke-width="1.5" 
                    stroke-linecap="round" 
                    stroke-linejoin="round" 
                    opacity="0.6"/>
            </svg>
          </span>
          <h2 class="folder-title">{{ folder.displayName }}</h2>
        </div>
        <span class="expand-icon" [class.rotated]="isFolderExpanded(folder.folderName)">
          ▼
        </span>
      </div>
      
      <div class="folder-content" *ngIf="isFolderExpanded(folder.folderName)">
        <div class="api-grid" *ngIf="folder.apiFiles.length > 0">
          <div 
            class="api-card" 
            *ngFor="let api of folder.apiFiles" 
            (click)="openApiViewer(api)"
          >
            <div class="api-card-header">
              <h3>{{ api.title }}</h3>
              <div class="version-info">
                <span class="version-badge default" title="Latest version">
                  v{{ api.version }}
                </span>
              </div>
            </div>
            <div class="api-card-body">
              <p class="description">{{ api.description }}</p>
            </div>
          </div>
        </div>
        
        <div class="no-files" *ngIf="folder.apiFiles.length === 0">
          <p class="empty-folder-message">No API specifications found in this folder.</p>
        </div>
      </div>
    </div>
  </div>

  <div class="no-apis" *ngIf="!loading && !error && apiFolders.length === 0">
    <p>No API specifications found.</p>
  </div>
</div>
